import React, { useEffect, useState } from 'react';
import Container from "@mui/material/Container";
import JumbotronComponent from "./JumbotronComponent";
import EventKeynoteComponent from './EventKeynoteComponent';
import { useGlobal } from '../../utils/GlobalContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PreviousKeynoteComponent from './PreviousKeynoteComponent';
import { SessionSpeaker } from '../../data/SessionData';
import { session, newSession } from '../../data/session';
import { UserProfile, newUserProfile } from '../../data/userProfile';
import SessionInfoModal from '../common/SessionInfoModal';
import SpeakerInfoModal from '../common/SpeakerInfoModal';
import { getEventById } from '../../services/cdn/Events';
  
export default function Home() {
    const [queryParameters,setSearchParams] = useSearchParams();
    const { state, } = useGlobal();
    const [onLoad, setOnLoad] = useState(false);
    const navigate = useNavigate();
    if (state.UserProfile.IsExistingUser === false && state.UserProfile.Id!=="") {
      navigate("/account");
    }
    // Routing Parameters
    useEffect(() => {
        if(queryParameters.get("s")!==null && onLoad===false && state.Profiles.length){
            handleSpeakerModalOpen(queryParameters.get("s")??"");
            setOnLoad(true);
            queryParameters.delete('s');
            setSearchParams(queryParameters);
        }else if(queryParameters.get("e")!==null 
            && queryParameters.get("ss")!==null 
            && onLoad===false && state.Conference.Events.length){
            handleSessionModalOpen(queryParameters.get("e")??"",queryParameters.get("ss")??"    ");
            setOnLoad(true);
            queryParameters.delete('e');
            queryParameters.delete('ss');
            setSearchParams(queryParameters);
        }
    });

    // Speaker Modal Hookup
    const [speakerInfoOpen, setSpeakerInfoOpen] = useState(false);
    const [selectedSpeaker, setSelectedSpeaker] = useState<UserProfile>(newUserProfile());
    const handleSpeakerModalOpen = (speakerName: string) => {
        const tempSelectedSpeaker: UserProfile[] = state.Profiles.filter(function (el){
            return `${el.FirstName} ${el.LastName}`.toUpperCase()=== speakerName.toUpperCase();
        });
        if(tempSelectedSpeaker.length===0)
            return;

        setSelectedSpeaker(tempSelectedSpeaker[0]);
        setSpeakerInfoOpen(true);
    };
    const handleSpeakerModalClose = () => {
        setSpeakerInfoOpen(false);
    };
    //http://localhost:3000/?e=f1c3b82e990a&ss=b15f0ff1c186
    // Session Modal Hookup
    const [sessionInfoOpen, setSessionInfoOpen] = useState(false);
    const [selectedSession, setSelectedSession] = useState<session>(newSession());
    const handleSessionModalOpen = async (eventId: string, sessionId: string) => {
        const fullEventIds: string[] = state.Conference.Events.filter(function (el){
            return el.toUpperCase().endsWith(eventId.toUpperCase());
        });
        if(fullEventIds.length===0)
            return;
        const eventData = await getEventById(fullEventIds[0]); 
        if(eventData.Sessions.length!==0){
            const sessionsData: session[] = eventData.Sessions.filter(function (el){
                return el.Id.toUpperCase().endsWith(sessionId.toUpperCase());
            });
            if(sessionsData.length===0)
                return;
            setSelectedSession(sessionsData[0]);
            setSessionInfoOpen(true);
            queryParameters.delete('e');
            queryParameters.delete('ss');
            setSearchParams(queryParameters);
        }
    };
    const handleSessionModalClose = () => {
        setSessionInfoOpen(false);
    };
            
    return (
        <>
            <div className="container">
                <Container maxWidth="xl">
                    <JumbotronComponent/>
                </Container>      
            </div>
            <EventKeynoteComponent/>
            <div className="container">
                <Container maxWidth="xl">
                    <PreviousKeynoteComponent/>
                </Container>      
            </div>
            <br/>
            <br/>
            <br/>
            <SpeakerInfoModal show={speakerInfoOpen} onClose={handleSpeakerModalClose} speaker={selectedSpeaker}/>
            <SessionInfoModal show={sessionInfoOpen} onClose={handleSessionModalClose} sessionModel={selectedSession}/>
        </>
    )
}